import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DetailsWidgetComponent } from '../details-widget/details-widget-component';
import { UserIconComponent } from '../user-icon/user-icon.component';
import { CopyToClipboardComponent } from '../copy-to-clipboard/copy-to-clipboard.component';
import { DividerComponent } from '../divider/divider.component';

export interface IAssociatedUser {
	userID: number;
	firstName: string;
	lastName: string;
	personalEmail: string;
	route?: string;
}

@Component({
	selector: 'lb-associated-contacts',
	standalone: true,
	imports: [DetailsWidgetComponent, UserIconComponent, CopyToClipboardComponent, RouterModule, DividerComponent],
	templateUrl: './associated-contacts.component.html',
	styleUrls: ['./associated-contacts.component.scss']
})
export class AssociatedContactsComponent {
	title = input<string>('Associated Contacts');
	users = input<IAssociatedUser[] | null | undefined>(null);
}
